import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCheck } = FiIcons;

const PerfectFor = () => {
  const events = [
    "Corporate Christmas parties",
    "Employee appreciation dinners",
    "End-of-year celebrations",
    "Staff recognition events",
    "Team holiday dinners",
    "Client appreciation events",
    "Department parties",
    "Nonprofit holiday events",
    "Leadership dinners"
  ];

  return (
    <section className="py-32 bg-spanish-ivory">
      <div className="max-w-5xl mx-auto px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-16"
        >
          <h2 className="font-serif text-3xl md:text-4xl text-mission-green mb-4">
            Perfect For December Company Celebrations
          </h2>
          <div className="h-0.5 w-16 bg-antique-gold mx-auto"></div>
        </motion.div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-8 text-left">
          {events.map((event, idx) => (
            <motion.div 
              key={idx}
              className="flex items-center gap-4 group"
              initial={{ opacity: 0, x: -10 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.05 * idx }}
            >
              <div className="w-6 h-6 rounded-full border border-antique-gold flex items-center justify-center text-antique-gold group-hover:bg-antique-gold group-hover:text-white transition-colors duration-300">
                <SafeIcon icon={FiCheck} className="text-xs" />
              </div>
              <span className="text-mission-green font-medium text-base group-hover:text-olive-sage transition-colors">{event}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PerfectFor;